import React, { Component } from "react";
import { comboBox, txtBox, datePicker } from "../utils/Forms";
import { Link } from "react-router-dom";
import Select from "react-select";
import { isEmpty } from "lodash";
export default class MemberForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      branches: [],
      countries: [],
      membership_statuses: [],
      errors: {}, //this is for server side errors
      profile: {}
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleProfessionChange = this.handleProfessionChange.bind(this);
    this.handleChurchGroupsChange = this.handleChurchGroupsChange.bind(this);
  }

  setProfileData(member = {}) {
    const profile = {
      id: member.id || null,
      first_name: member.first_name || "",
      membership_number: member.membership_number || "",
      last_name: member.last_name || "",
      maiden_name: member.maiden_name || "",
      other_names: member.other_names || "",
      gender: member.gender || "",
      email: member.email || "",
      postal_address: member.postal_address || "",
      residential_address: member.residential_address || "",
      date_of_birth: member.date_of_birth || "",
      branch_id: member.branch_id || "",
      house_phone: member.house_phone || "",
      phone_number: member.phone_number || "",
      old_registration_number: member.old_registration_number || "",
      area_of_residence: member.area_of_residence || "",
      denomination: member.denomination || "",
      nationality: member.nationality || "",
      country_of_residence: member.country_of_residence || "",
      profession: member.profession || "",
      title: member.title || "",
      church_groups: member.church_groups || "",
      membership_status: member.membership_status || ""
    };
    this.setState({ profile, loading: false });
  }

  setLookups({ branches, countries, church_groups, membership_statuses }) {
    this.setState({ branches, countries, church_groups, membership_statuses });
  }

  componentWillReceiveProps(nextProps) {
    this.setLookups(nextProps.lookups);
    this.setProfileData(nextProps.member);
  }

  handleChange(event) {
    const target = event.target;
    const name = target.name;
    const value = target.type === "checkbox" ? target.checked : target.value;

    let newProfile = { ...this.state.profile, [name]: value };

    this.setState({ ...this.state, profile: newProfile });
  }

  handleDateChange(newDate) {
    let newProfile = { ...this.state.profile, date_of_birth: newDate };
    this.setState({ ...this.state, profile: newProfile });
  }

  isMemberValid(profile) {
    let errors = {};
    const {
      title,
      first_name,
      last_name,
      date_of_birth,
      branch_id,
      nationality,
      country_of_residence,
      gender,
      area_of_residence,
      residential_address,
      phone_number,
      membership_status,
      profession
    } = profile;

    if (isEmpty(title)) {
      errors["title"] = "Title is required";
    }

    if (isEmpty(first_name)) {
      errors["first_name"] = "First name is required";
    }

    if (isEmpty(last_name)) {
      errors["last_name"] = "Last name is required";
    }

    if (isEmpty(gender)) {
      errors["gender"] = "Gender is required";
    }

    if (isEmpty(date_of_birth)) {
      errors["date_of_birth"] = "Date of birth required";
    }

    if (isEmpty(area_of_residence)) {
      errors["area_of_residence"] = "Area of residence is required";
    }

    if (isEmpty(residential_address)) {
      errors["residential_address"] = "Residential address is required";
    }

    if (isEmpty(phone_number)) {
      errors["phone_number"] = "Phone number is required";
    }

    if (isEmpty(profession)) {
      errors["profession"] = "Profession is required";
    }

    if (isEmpty(nationality)) {
      errors["nationality"] = "Nationality is required";
    }

    if (isEmpty(membership_status)) {
      errors["membership_status"] = "Membership status is required";
    }

    if (isEmpty(country_of_residence)) {
      errors["country_of_residence"] = "Coutry of residence is required";
    }

    if (!!branch_id === false) {
      errors["branch_id"] = "Branch is required";
    }

    this.setState({ errors });
    return isEmpty(errors);
  }

  handleSubmit(event) {
    if (this.isMemberValid(this.state.profile)) {
      this.props.saveMember(this.state.profile);
    }
    event.preventDefault();
  }

  handleChurchGroupsChange(values) {
    let newProfile = { ...this.state.profile, church_groups: values };
    this.setState({ ...this.state, profile: newProfile });
  }

  handleProfessionChange(option) {
    let newProfile = { ...this.state.profile, profession: option };
    this.setState({ ...this.state, profile: newProfile });
  }

  render() {
    let {
      first_name,
      last_name,
      maiden_name,
      other_names,
      email,
      gender,
      branch_id,
      residential_address,
      postal_address,
      date_of_birth,
      house_phone,
      phone_number,
      country_of_residence,
      nationality,
      membership_number,
      title,
      denomination,
      church_groups,
      profession,
      area_of_residence,
      old_registration_number,
      membership_status
    } = this.state.profile;

    const errors = this.state.errors;
    const buttonText = this.props.match.params.id ? "Update" : "Create";

    const genderOptions = ["", "male", "female"];
    const titleOptions = [
      "",
      "Mr.",
      "Mrs.",
      "Miss.",
      "Dr.",
      "Prof.",
      "Pastor",
      "Bishop",
      "Rev",
      "Major",
      "Captain",
      "General",
      "Justice",
      "Ambassador",
      "Other"
    ];
    const branchNames = [""].concat(
      this.state.branches.map(branch => branch.name)
    );
    const branchValues = [""].concat(
      this.state.branches.map(branch => branch.id)
    );

    const membershipStatusValues = [""].concat(
      this.state.membership_statuses.map(mbs => mbs.value)
    );
    const membershipStatusNames = [""].concat(
      this.state.membership_statuses.map(mbs => mbs.label)
    );

    const countries = [""].concat(this.state.countries);
    const church_groups_list = this.state.church_groups;

    let { loading } = this.state;
    let form = (
      <div className="row">
        <form onSubmit={this.handleSubmit}>
          <div className="clearfix">
            <div className="row">
              {txtBox(
                "Membership Number",
                "membership_number",
                membership_number,
                this,
                { disabled: "true", errors }
              )}
              {txtBox(
                "Old Membership Number",
                "old_registration_number",
                old_registration_number,
                this,
                { errors }
              )}
              {comboBox("Title", "title", title, this, titleOptions, [], {
                errors
              })}
              {txtBox("First Name", "first_name", first_name, this, { errors })}
            </div>

            <div className="row">
              {txtBox("Last Name", "last_name", last_name, this, { errors })}
              {txtBox("Other Name", "other_names", other_names, this, {
                errors
              })}
              {txtBox("Maiden Name", "maiden_name", maiden_name, this, {
                errors
              })}
              {txtBox("Email", "email", email, this, { errors })}
            </div>
            <div className="row">
              {datePicker(
                "Date Of Birth",
                "date_of_birth",
                date_of_birth,
                this.handleDateChange,
                { errors }
              )}
              {" "}
              {comboBox("Gender", "gender", gender, this, genderOptions, [], {
                errors
              })}
              {txtBox(
                "Postal Address",
                "postal_address",
                postal_address,
                this,
                {
                  errors
                }
              )}
              {txtBox(
                "Residential Address",
                "residential_address",
                residential_address,
                this,
                { errors }
              )}
            </div>

            <div className="row">
              {txtBox("House Phone", "house_phone", house_phone, this, {
                errors
              })}
              {txtBox("Mobile Number", "phone_number", phone_number, this, {
                errors
              })}
              {comboBox(
                "Branch",
                "branch_id",
                +branch_id,
                this,
                branchNames,
                branchValues,
                { errors }
              )}
              {comboBox(
                "Nationality",
                "nationality",
                nationality,
                this,
                countries,
                [],
                { errors }
              )}
              {" "}
            </div>
            <div className="row">
              {comboBox(
                "Country of residence",
                "country_of_residence",
                country_of_residence,
                this,
                countries,
                [],
                { errors }
              )}

              {txtBox(
                "Area of residence",
                "area_of_residence",
                area_of_residence,
                this,
                { errors }
              )}

              {txtBox("Profession", "profession", profession, this, { errors })}

              {txtBox("Denomination", "denomination", denomination, this, {
                errors
              })}
            </div>
            <div className="row">
              {comboBox(
                "Memberhsip Status",
                "membership_status",
                membership_status,
                this,
                membershipStatusNames,
                membershipStatusValues,
                { errors }
              )}
            </div>

            <div className="row">
              <div className="col-md-12">
                <label> Church groups </label>
                <Select
                  multi
                  simpleValue
                  value={church_groups}
                  placeholder="Church Groups"
                  urn
                  options={church_groups_list}
                  onChange={this.handleChurchGroupsChange}
                />
              </div>
            </div>
          </div>
          <div className="col-md-12 edit-buttons-pane">
            <input
              className="btn btn-success pull-right"
              type="submit"
              value={buttonText}
            />
            <Link
              to="/members"
              className="btn btn-default pull-right"
              style={{ marginRight: 10 }}
            >
              {" "}Cancel{" "}
            </Link>
          </div>
        </form>
      </div>
    );

    let content = form;
    if (loading) {
      content = (
        <div style={{ textAlign: "center" }}> Loading... please wait </div>
      );
    }

    return (
      <div>
        {content}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MemberForm.js